module.exports = __webpack_public_path__ + "static/media/TruckIcon.b58ec6be.svg";